import api from './api'

/**
 * Listar clientes del SaaS multi-tenant.
 * Por defecto trae todos: vacíos e inactivos incluidos, para que la UI filtre del lado del front.
 */
export async function listClients({
  includeEmpty = true,
  includeInactive = true,
  businessOnly = false
} = {}) {
  const params = {}
  if (includeEmpty) params.include_empty = true
  if (includeInactive) params.include_inactive = true
  if (businessOnly) params.business_only = true

  const response = await api.get('/clients', { params })
  return response.data
}

/**
 * Detalle de un cliente: incluye usuarios y CVUs.
 */
export async function getClient(id) {
  const response = await api.get(`/clients/${id}`)
  return response.data
}

/**
 * Crear un cliente nuevo.
 * @param {{ name: string, slug?: string, bank_role?: 'CREDENCIAL'|'BIND' }} payload
 */
export async function createClient(payload) {
  const response = await api.post('/clients', payload)
  return response.data
}

/**
 * Actualizar campos de un cliente.
 * Cualquier campo no enviado se mantiene como está en el backend.
 */
export async function updateClient(id, payload) {
  const response = await api.put(`/clients/${id}`, payload)
  return response.data
}

/**
 * Crear el primer admin de un cliente (rol client_admin / portal_role administrador).
 */
export async function createClientAdmin(clientId, payload) {
  const response = await api.post(`/clients/${clientId}/admin`, payload)
  return response.data
}

/**
 * Crear un usuario operativo de un cliente (rol supervisor / portal_role principal).
 */
export async function createClientUser(clientId, payload) {
  const response = await api.post(`/clients/${clientId}/users`, payload)
  return response.data
}

/**
 * Inventario de CVUs cargados en client_accounts.
 */
export async function listInventoryAccounts({ clientId, status = 'active', limit } = {}) {
  const params = {}
  if (clientId != null) params.client_id = clientId
  if (status) params.status = status
  if (limit != null) params.limit = limit

  const response = await api.get('/clients/inventory/accounts', { params })
  return response.data
}
